import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var IntervalTimetable;
(function (IntervalTimetable) {
    IntervalTimetable.default_object = {
        time_intervals: [],
        outside_default: 2930,
        setting_register: 0,
    };
    IntervalTimetable.get = createAccessors(arrayGetSet('interval_timetables'), IntervalTimetable.default_object);
})(IntervalTimetable || (IntervalTimetable = {}));
